import { HttpClient } from '@angular/common/http';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { extractData } from '@shared/operators/extractData';
import { IResponse } from '@shared/models';

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<Record<string, string>> {
    if (lang === 'en') {
      // Load the static file for English translations
      return this.http
        .get<
          {
            key: string;
            value: string;
          }[]
        >(`/i18n/en.json`)
        .pipe(
          map((res) =>
            res.reduce(
              (acc, { key, value }) => {
                acc[key] = value;
                return acc;
              },
              {} as Record<string, string>,
            ),
          ),
        );
    } else {
      // Call the backend for other languages
      return this.http
        .get<
          IResponse<
            {
              key: string;
              value: string;
            }[]
          >
        >(`${environment.apiBaseUrl}api/translations/uiLabels`)
        .pipe(
          extractData(),
          map((res) =>
            res.reduce(
              (acc, { key, value }) => {
                acc[key] = value;
                return acc;
              },
              {} as Record<string, string>,
            ),
          ),
        );
    }
  }
}

export const provideI18n = () => {
  return provideTranslateService({
    loader: {
      provide: TranslateLoader,
      useFactory: (http: HttpClient) => new CustomTranslateLoader(http),
      deps: [HttpClient],
    },
  });
};
